// redux/store/wishlist.js
import { createSlice } from "@reduxjs/toolkit";
import { act } from "react";

const wishlistSlice = createSlice({
  name: "wishlist",
  initialState: { wishlistItems: [] },
  reducers: {
    addToWishlist: (state, action) => {
      const exists = state.wishlistItems.some(
        (i) => i.id === action.payload.id,
      );
      console.log(action.payload);
      if (!exists) state.wishlistItems.push(action.payload);
    },
    removeFromWishlist: (state, action) => {
      state.wishlistItems = state.wishlistItems.filter(
        (i) => i.id !== action.payload,
      );
    },
  },
});

export const { addToWishlist, removeFromWishlist } = wishlistSlice.actions;
export default wishlistSlice.reducer;
